import { render, staticRenderFns } from "./casesDoKeep.vue?vue&type=template&id=5f1188e4&scoped=true"
import script from "./casesDoKeep.vue?vue&type=script&lang=js"
export * from "./casesDoKeep.vue?vue&type=script&lang=js"
import style0 from "./casesDoKeep.vue?vue&type=style&index=0&id=5f1188e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1188e4",
  null
  
)

export default component.exports